// src/store/modules/common/pagination.js
export const defaultPagination = () => ({
  currentPage: 1,
  pageSize: 10,
  totalRecords: 0,
  totalPages: 0,
  hasPrevious: false,
  hasNext: false,
});

/**
 * Creates a pagination module with uniquely-prefixed mutation names
 * to avoid collisions across non-namespaced Vuex store modules.
 *
 * Usage:
 *   const pagination = createPaginationModule('AVAILABILITY');
 *   // mutations: { ...pagination.mutations }
 *   // commit:    commit(pagination.SET_PAGINATION, { ... })
 */
export const createPaginationModule = (prefix) => {
  const SET = `SET_${prefix}_PAGINATION`;
  const RESET = `RESET_${prefix}_PAGINATION`;

  return {
    SET_PAGINATION: SET,
    RESET_PAGINATION: RESET,
    mutations: {
      [SET](state, paginationData) {
        state.pagination = {
          ...state.pagination,
          ...paginationData,
        };
      },
      [RESET](state) {
        state.pagination = defaultPagination();
      },
    },
  };
};

// Legacy export — kept for reference but should no longer be spread into modules.
export const paginationModule = {
  state: () => ({
    pagination: defaultPagination(),
  }),

  mutations: {
    SET_PAGINATION(state, paginationData) {
      state.pagination = {
        ...state.pagination,
        ...paginationData,
      };
    },
    RESET_PAGINATION(state) {
      state.pagination = defaultPagination();
    },
  },

  getters: {
    pagination: (state) => state.pagination,
  },

  actions: {
    updatePagination({ commit }, paginationData) {
      commit("SET_PAGINATION", paginationData);
    },
    resetPagination({ commit }) {
      commit("RESET_PAGINATION");
    },
  },
};
